import { Box, Image, Typography } from "@outschool/backpack";
import { renderCurrencyString, useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import {
  CENTS_UPPER_LIMIT,
  useUserWalletSummary
} from "@outschool/ui-components-website";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";

import walletImage from "../../../../images/wallet-cta.svg";

/**
 * The desktop/responsive version of the wallet funds CTA
 */
export function WalletCTABanner() {
  const { t } = useTranslation(
    "client\\components\\loggedInHome\\walletCTA\\WalletCTABanner"
  );
  const { currentUser } = useSession();
  const hasActiveSubscription = !!currentUser?.hasSubscription;
  const { totalBalanceCents, loading: summaryLoading } = useUserWalletSummary();

  if (!totalBalanceCents || summaryLoading || hasActiveSubscription) {
    return null;
  }

  const totalBalanceDollars =
    totalBalanceCents > CENTS_UPPER_LIMIT
      ? `${renderCurrencyString({
          priceInCents: CENTS_UPPER_LIMIT,
          showCurrencyCode: false,
          displayNoCents: true
        })}+`
      : renderCurrencyString({
          priceInCents: totalBalanceCents,
          showCurrencyCode: false,
          displayNoCents: true
        });

  const childNames = currentUser?.children?.map(child => child.name) ?? [];
  let yourLearnersCopy = t(
    "Use it towards classes based on your learner’s interests!"
  );
  if (childNames.length === 1 && childNames[0]) {
    yourLearnersCopy = t(
      "Use it towards classes based on {{learnerName}}’s interests!",
      { learnerName: childNames[0] }
    );
  } else if (childNames.length === 2 && childNames[0] && childNames[1]) {
    yourLearnersCopy = t(
      "Use it towards classes based on {{learnerName1}} and {{learnerName2}}’s interests!",
      { learnerName1: childNames[0], learnerName2: childNames[1] }
    );
  } else if (childNames.length > 2) {
    yourLearnersCopy = t(
      "Use it towards classes based on your learners’ interests!"
    );
  }

  return (
    <Container sx={{ display: "flex" }}>
      <Box
        flex
        sx={{
          width: "100%",
          padding: "1em 1.5em",
          alignItems: "center"
        }}
      >
        <Image src={walletImage} alt="" role="presentation" />
        <Box sx={{ marginLeft: "1.5em" }}>
          <Typography
            sx={{
              fontWeight: "700",
              color: "success.600"
            }}
            variant="h4"
          >
            {t("Your Outschool balance is {{ totalBalance }}", {
              totalBalance: totalBalanceDollars
            })}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              marginTop: "0.25em"
            }}
          >
            {yourLearnersCopy}
          </Typography>
        </Box>
      </Box>

      {/* inset background */}
      <Box
        sx={{
          zIndex: -1,
          width: "100%",
          marginLeft: "-100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            marginY: "2em",
            borderRadius: "0.5em",
            backgroundColor: "success.100"
          }}
        />
      </Box>
    </Container>
  );
}
